import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';

var checkPopoverArrowProp = function checkPopoverArrowProp(props, propName, componentName) {
  var prop = props[propName];

  if (!React.isValidElement(prop) && prop !== false && prop !== undefined) {
    return new Error("Invalid prop " + propName + " supplied to " + componentName + ". Validation failed.");
  }

  return null;
};

checkPopoverArrowProp.isRequired = function (props, propName, componentName) {
  var other = [];

  for (var _i = 3; _i < arguments.length; _i++) {
    other[_i - 3] = arguments[_i];
  }

  var prop = props[propName];

  if (prop === undefined) {
    return new Error("Prop " + propName + " has not been supplied to " + componentName + ", but is required.");
  } // eslint-disable-next-line no-useless-call


  return checkPopoverArrowProp.call.apply(checkPopoverArrowProp, tslib_1.__spread([null, props, propName, componentName], other));
};

export { checkPopoverArrowProp };
export var componentType = PropTypes.oneOfType([// stateless component. example: const Icon = () => <i/>
PropTypes.func, // dom element. example: div
PropTypes.string, // native components. example: Fragment
PropTypes.symbol]);

try {
  // @ts-ignore
  propTypes.__docgenInfo = {
    "description": "",
    "displayName": "propTypes",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}